// Bridge between turbo-rails gem (server-side turbo_stream_from helper) and AnyCable.
// Replaces @rails/actioncable with AnyCable's ActionCable-compatible consumer,
// sharing the same WebSocket connection used by the presence system.

import { consumer } from "./cable"
import { connectStreamSource, disconnectStreamSource } from "@hotwired/turbo"

function snakeize(obj) {
  if (!obj || typeof obj !== "object") return obj
  return Object.keys(obj).reduce((acc, key) => {
    const snaked = key[0].toLowerCase() + key.slice(1).replace(/([A-Z]+)/g, (m, x) => "_" + x.toLowerCase())
    acc[snaked] = obj[key]
    return acc
  }, {})
}

class TurboCableStreamSourceElement extends HTMLElement {
  static observedAttributes = ["channel", "signed-stream-name"]

  async connectedCallback() {
    connectStreamSource(this)
    this.subscription = consumer.subscriptions.create(this.channel, {
      received: this.dispatchMessageEvent.bind(this),
      connected: this.subscriptionConnected.bind(this),
      disconnected: this.subscriptionDisconnected.bind(this),
    })
  }

  disconnectedCallback() {
    disconnectStreamSource(this)
    if (this.subscription) this.subscription.unsubscribe()
    this.subscriptionDisconnected()
  }

  attributeChangedCallback() {
    if (this.subscription) {
      this.disconnectedCallback()
      this.connectedCallback()
    }
  }

  dispatchMessageEvent(data) {
    const event = new MessageEvent("message", { data })
    return this.dispatchEvent(event)
  }

  subscriptionConnected() {
    this.setAttribute("connected", "")
  }

  subscriptionDisconnected() {
    this.removeAttribute("connected")
  }

  get channel() {
    const channel = this.getAttribute("channel")
    const signed_stream_name = this.getAttribute("signed-stream-name")
    return { channel, signed_stream_name, ...snakeize({ ...this.dataset }) }
  }
}

if (customElements.get("turbo-cable-stream-source") === undefined) {
  customElements.define("turbo-cable-stream-source", TurboCableStreamSourceElement)
}
